import React, { useEffect, useState } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';

const Header = ({ toggleSidebar, user = { name: '', profileImage: '' }, loadingUser = false }) => {
  const [userState, setUserState] = useState({ name: '', profileImage: '' });

  useEffect(() => {
    // Get user data from localStorage only
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUserState({
        name: parsedUser.name || 'User',
        profileImage: parsedUser.profileImage || 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
      });
    }
  }, []);

  return (
    <header className="bg-gray-200 py-3 flex items-center justify-between border-b border-gray-300 sticky top-0 z-30">
      {/* Left: Hamburger on small screens */}
      <div className="lg:hidden">
        <button onClick={toggleSidebar} className="text-gray-700 focus:outline-none px-4">
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      {/* Search bar (hidden on small screens) */}
      <div className="hidden lg:flex items-center">
        <div className="relative">
          {/* Search bar removed */}
        </div>
      </div>

      {/* Profile section */}
      <div className="hidden lg:flex items-center space-x-4">
        {/* <div className="p-2 bg-white rounded-full shadow hover:shadow-md cursor-pointer">
          <BellIcon className="h-5 w-5 text-gray-600" />
        </div> */}
        <div className="flex items-center space-x-3 pl-4 pr-6">
          <img
            src={userState.profileImage}
            alt={userState.name}
            className="h-9 w-9 rounded-full object-cover border-2 border-white shadow-sm"
            onError={e => { e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png"; }}
          />
          <span className="text-sm text-gray-800 font-medium">{userState.name}</span>
        </div>
      </div>
    </header>
  );
};

export default Header;
